import './styles/TableAlerts.css'
import ReactDOM from 'react-dom';
import React from 'react';
import Modal from 'react-modal';
import RowProblem from './RowProblem'
import LoadAlerts from './LoadAlerts'
import { useFetch } from '../hooks/useFetch';
import { useState, useEffect } from 'react';
import Search from './generales/Search';
import Select from 'react-select';
import Paginador from './generales/Paginador'
import { capitalizeFirstLetter } from '../utils/utils';
import { lang } from './generales/traduction';
import ModalAddProblem from './monitor-components/ModalAddProblem';
import ModalMasiveDelete from './monitor-components/ModalMasiveDelete';
// const customStyles = {
//     content: {
//       top: '50%',
//       left: '50%',
//       right: 'auto',
//       bottom: 'auto',
//       marginRight: '-50%',
//       transform: 'translate(-50%, -50%)',
//     },
//   };
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: 'var(--white-color)',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    height: '80%',
    padding: '20px',
    border: '1px solid red !important'
  },
};
const addHostModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    height: '85%',
    padding: '20px'
  },
};
const MasiveDeleteModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    height: '80%',
    padding: '20px'
  },
};
const TableAlerts = (props) => {
  // console.log(props.dataProblemsError)
  // console.log(dataAgencies)
  const [modalLogIsOpen, setLogIsOpen] = React.useState(false);
  const [openSelectList, setOpenSelect] = useState(false)
  const [orderAsc, setOrderAsc] = useState(true)
  const [problems, setProblems] = useState(props.dataProblems.data)
  const [flagSearch, setFlagsearch] = useState(false)
  const [allSelected, setAllSelected] = useState(false)
  const [openEventErrors, setOpenEventsErrors] = useState(false)
  const [poolRows, setPoolRows] = useState([])
  const [poolObjectRows, setPoolObjectRows] = useState([])
  const eventErrors = (props.dataProblemsError.data.length == 0) ? [] : props.dataProblemsError.data
  const [modalAddCorIsOpen, setAddCorIsOpen] = React.useState(false);
  const [modalMasiveDeleteIsOpen, setMasiveDeleteIsOpen] = React.useState(false);
  const token_item = localStorage.getItem('access_token')
  const todoListUser = useFetch('cassia/user/to_do_events', '', token_item, 'GET', props.server)
  const [loadingM, setLoadingM] = useState(false);
  function openModalMasiveDelete() {
    setMasiveDeleteIsOpen(true);
  }

  function closeModalMasiveDelete() {
    setMasiveDeleteIsOpen(false);
  }
  function openModal() {
    setLogIsOpen(true);
  }

  function closeModal() {
    setLogIsOpen(false);
  }

  function openModalAddCor() {
    setAddCorIsOpen(true);
  }

  function closeModalAddCor() {
    setPoolObjectRows([])
    setPoolRows([])
    setAllSelected(false)
    setAddCorIsOpen(false);
  }

  // Exponer acciones al padre vía props
  useEffect(() => {
    if (props.onOpenCorrelacion) {
      props.onOpenCorrelacion.current = openModalAddCor;
    }
    if (props.onOpenCierreMasivo) {
      props.onOpenCierreMasivo.current = openModalMasiveDelete;
    }
  }, [props.onOpenCorrelacion, props.onOpenCierreMasivo]);

  useEffect(() => {
    if (props.onPoolRowsChange) {
      props.onPoolRowsChange(poolRows.length);
    }
  }, [poolRows]);
  function expandAlerts() {
    // console.log(typeof props.search_problems)
    if (!props.modalIsOpen) {
      props.search_problems()
      if (props.alertsIsOpen) {
        props.setAlertsIsOpen(false)
      } else {
        props.setAlertsIsOpen(true)
      }
    }


  }
  useEffect(() => {
    setPoolObjectRows([])
    setPoolRows([])
    setAllSelected(false)
  }, [props.dataProblems.loading])
  useEffect(() => {

    setProblems(props.dataProblems.data)
  }, [props.dataProblems.data])
  useEffect(() => {
    setOpenSelect(false)
  }, [props.modalIsOpen])
  const openSelector = () => {
    setOpenSelect(!openSelectList)
  }
  useEffect(() => {
    // props.search_problems()
    setFlagsearch(true)
  }, [props.severityProblms])
  const handleSelectAll = () => {
    if (allSelected) {
      // Si ya está todo seleccionado, deselecciona todo
      setPoolRows([]);
      setPoolObjectRows([])
    } else {
      setPoolRows(dataList.map(item => item.eventid))
      setPoolObjectRows(dataList)
    }
    setAllSelected(!allSelected); // Alterna el estado de seleccionar todo
  };
  const selectOptionList = (element) => {

    if (props.severityProblms.includes(element.value)) {
      // Si existe, eliminarlo
      const newArray = props.severityProblms.filter(value => value !== element.value);
      // console.log(newArray); // Output: [1, 3]
      props.setSeverityProblms(newArray)
    } else {
      props.setSeverityProblms([...props.severityProblms, ...element.value])
    }

    const index = props.optionsSelectList.findIndex((option) => option.value === element.value);

    if (index !== -1) {
      // Clonar el array actual para evitar mutar el estado directamente
      const updatedOptions = [...props.optionsSelectList];

      // Actualizar el atributo status del objeto en el índice encontrado
      updatedOptions[index] = {
        ...updatedOptions[index],
        status: !updatedOptions[index].status, // Invertir el valor de status
      };

      // Actualizar el estado con el nuevo array
      props.setOptionsSelectList(updatedOptions);


    }
  }

  const [countList, setCountList] = useState(0)
  var dataList = (props.searchTerm === '') ? problems : props.searchResults;
  // var dataList=props.searchResults;
  // console.log("datalist desde table alert ************************s*********************************")
  // console.log(dataList)
  // console.log(dataList.length)
  const contOrigen = dataList.filter(elemento => elemento.tipo === 1).length;
  const contZabbix = dataList.length;
  const contProblem = dataList.filter(elemento => elemento.Estatus === 'PROBLEM').length;
  const contResolved = dataList.filter(elemento => elemento.Estatus === 'RESOLVED').length;
  // console.log(contadorTipo1)
  const [limitList, setLimitList] = useState(100);
  const [pageActual, setPageActual] = useState(1);
  const startLimit = limitList * pageActual - limitList;
  const startLimitRow = startLimit;
  const endLimitRow = limitList * pageActual;
  const pages = parseInt(dataList.length / limitList) + 1;
  useEffect(() => {
    setCountList(dataList.length)
  }, [dataList])
  const formatDateTime = (dateTimeString) => {
    // Dividir la cadena en fecha y hora
    const [datePart, timePart] = dateTimeString.split(' ');

    // Dividir la parte de la fecha en día, mes y año
    const [day, month, year] = datePart.split('/');

    // Reconstruir la cadena en el formato deseado
    const formattedDateTime = `${year}/${month}/${day} ${timePart}`;

    return formattedDateTime;
  };
  const [attrSelected, setAttrSelected] = useState('')
  const orderByAtter = (attr) => {
    setAttrSelected(attr)
    if (dataList.length === 0) {
      return;
    }

    const sortedData = [...dataList].sort((a, b) => {
      if (orderAsc) {
        setOrderAsc(false)
        if (a[attr] > b[attr]) return 1;
        if (a[attr] < b[attr]) return -1;
      } else {
        setOrderAsc(true)
        if (a[attr] < b[attr]) return 1;
        if (a[attr] > b[attr]) return -1;
      }
      return 0
    });

    if (orderAsc) { } else { }

    // Actualizar estado o hacer lo que necesites con sortedData
    setProblems(sortedData);
  };
  const orderBy = (attr) => {
    setAttrSelected(attr)
    if (dataList.length === 0) {
      return;
    }

    const sortedData = [...dataList].sort((a, b) => {
      if (orderAsc) {
        setOrderAsc(false)
        if (formatDateTime(a[attr]) > formatDateTime(b[attr])) return 1;
        if (formatDateTime(a[attr]) < formatDateTime(b[attr])) return -1;
      } else {
        setOrderAsc(true)
        if (formatDateTime(a[attr]) < formatDateTime(b[attr])) return 1;
        if (formatDateTime(a[attr]) > formatDateTime(b[attr])) return -1;
      }
      return 0;
    });

    if (orderAsc) { } else { }

    // Actualizar estado o hacer lo que necesites con sortedData
    setProblems(sortedData);
  };
  function exportData() {
    // console.log('exportData')
    // setDataProblems({data:dataProblems.data,loading:true,error:dataProblems.error})
    const fetchData = async () => {
      // console.log('fetch')
      // console.log(+props.ubiActual)
      try {
        const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJqdWFuLm1hcmNpYWwiLCJleHAiOjE2OTExNjg3ODZ9.LETk5Nu-2WXF571qMqTd__RxHGcyOHzg4GfAbiFejJY'; // Reemplaza con tu token de autenticación
        const devicefilter = props.ubiActual.dispId !== 0 ? '?tech_host_type=' + props.ubiActual.dispId : ''
        const subtypefilter = props.ubiActual.templateId !== 0 ? 'subtype=' + props.ubiActual.templateId : ''
        const severityfilter = props.severityProblms.length > 0 ? 'severities=' + props.severityProblms.join(', ') : ''
        let andAux = (devicefilter !== '') ? '&' : '?'
        andAux = (subtypefilter !== '') ? andAux : ''

        const response = await fetch(props.server.url + '/api/v1/zabbix/problems/download/' + props.ubiActual.groupid + '' + devicefilter + andAux + subtypefilter + ((props.ubiActual.dispId == 0 && props.ubiActual.templateId == 0) ? '?' : '&') + severityfilter, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        });
        if (response.ok) {
          try {
            const response_data = await response.blob();
            // console.log(response_data)

            // Crear un enlace para descargar el archivo
            const url = window.URL.createObjectURL(response_data);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'data_problems.xlsx'); // Cambia el nombre y la extensión del archivo
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          } catch (error) {
            console.error('Error al descargar el archivo', error);
          }

        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        // Manejo de errores
        // setDataProblems({data:dataProblems.data,loading:dataProblems.loading,error:error})
        console.error(error);
      }
    };

    fetchData();

  }
  //  const [filtraOrigen,setFiltraOrigen]=useState((props.ubiActual.dispId==-1)?true:false)
  const [filtraOrigen, setFiltraOrigen] = useState((props.severityProblms[0] == 6) ? true : false)
  function search_severitys() {
    // console.log(props.severityProblms)
    if (props.severityProblms.length === 1 && props.severityProblms[0] == 6) {
      // props.search_problems()
      //   console.log("filtra")
      setFiltraOrigen(true)
      // setOpenSelect(false);
      // props.setSearchTerm("")
    } else {
      setFiltraOrigen(false)
      // props.search_problems();setFlagsearch(false);setOpenSelect(false);props.setSearchTerm("")
    }

    props.search_problems(); setFlagsearch(false); setOpenSelect(false); props.setSearchTerm("")
  }
  const handleSelectChange = (e) => {
    setPageActual(1)
    setLimitList(e.target.value); setPageActual(1);
  };
  const AddTodoLst = () => {
    const mergedArray = todoListUser.data.data.event_ids.concat(poolRows);
    //  props.setAutoRefresh(false)
    setLoadingM(true)
    const fetchDataPost = async () => {

      try {
        const response = await fetch(props.server.url + '/api/v1/cassia/user/to_do_events/', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
          body: JSON.stringify({
            "event_ids": mergedArray
          })
        });
        if (response.ok) {

          const data1 = await response.json();
          setLoadingM(false)
          // Manejo de la respuesta
          // setData(data1)
          props.search_problems()
          props.handleShowPopup(capitalizeFirstLetter(lang[props.languaje]['completado']), 'eventos agregados correctamente a lista personal ', '', true)
          // props.handleShowPopup(capitalizeFirstLetter(lang[props.languaje]['completado']),capitalizeFirstLetter((lang[props.languaje]['regDeleteCorr'])),'', true)
          // const url = window.location.origin + '/todoList';
          // window.open(url, '_blank');
          // setTimeout( window.open(url, '_blank'),2000)

          // console.log(data1);
        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        // Manejo de errores
        props.handleShowPopup('Error!!!', capitalizeFirstLetter(lang[props.languaje]['regDeleteNoCorr']), capitalizeFirstLetter(lang[props.languaje]['reportError']), false)
        // setError(error)
        console.error(error);
      }
    };

    fetchDataPost();
  }
  const OpenTodoLst = () => {
    const url = window.location.origin + '/todoList';
    window.open(url, '_blank');
  }
  return (
    <>
      <div className="ev-toolbar" onClick={(!props.alertsIsOpen) ? expandAlerts : () => { }}>
        {(props.modalIsOpen || props.alertsIsOpen) && (
          <>
            <div className="ev-search">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
              <input
                placeholder={capitalizeFirstLetter(lang[props.languaje]['buscar']) + "..."}
                value={props.searchTerm}
                type="text"
                onChange={(e) => {
                  const term = e.target.value;
                  props.setSearchTerm(term);
                  const filteredResults = problems.filter((item) => {
                    return Object.values(item).some((value) =>
                      String(value).toLowerCase().includes(term.toLowerCase())
                    );
                  });
                  props.setSearchResults(filteredResults);
                }}
              />
            </div>

            <div className="ev-filter-sel" onClick={openSelector} style={{ position: 'relative' }}>
              <span>
                {(props.severityProblms == "") ? 'Severidades...' : props.severityProblms.map((element, index) => (
                  element == "6" ? 'Down Origen' : (element == "7" ? 'Down Origen' : 'S' + element)
                )).join(', ')}
              </span>
              <svg width="10" height="10" viewBox="0 0 10 10" style={{ transform: openSelectList ? 'rotate(180deg)' : 'none', transition: 'transform 0.3s' }}>
                <polyline points="2,3.5 5,6.5 8,3.5" fill="none" stroke="#6b7280" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
              </svg>

              {openSelectList && (
                <div className="select-multiple-list" style={{ position: 'absolute', top: '100%', left: 0, width: '200px', marginTop: '4px', zIndex: '30' }}>
                  {(props.ubiActual.dispId == -1) ? (
                    <div className={'row-option-select-list option_bloqueado'}>
                      <input defaultChecked={true} onClick={() => selectOptionList(6)} value={6} name="r" type="checkbox" id={`checkboxList-${6}`} />
                      <label htmlFor={`checkboxList-${0}`}>{props.optionsSelectList[0].label}</label>
                    </div>
                  ) : (
                    props.optionsSelectList.map((element, index) => (
                      <div key={index} className={'row-option-select-list ' + (((props.severityProblms == "6" && props.optionsSelectList[index].value != "6") || (props.severityProblms != "" && props.severityProblms != "6" && props.optionsSelectList[index].value == "6")) ? 'option_bloqueado' : '')}>
                        <input defaultChecked={props.optionsSelectList[index].status} onClick={() => selectOptionList(element)} value={props.optionsSelectList[index].value} name="r" type="checkbox" id={`checkboxList-${index}`} />
                        <label htmlFor={`checkboxList-${index}`}>{props.optionsSelectList[index].label}</label>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>

            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ cursor: 'pointer', marginLeft: '4px' }} onClick={(e) => { e.stopPropagation(); search_severitys(); }} title="Filtrar">
              <line x1="4" y1="6" x2="20" y2="6"></line>
              <line x1="4" y1="12" x2="20" y2="12"></line>
              <line x1="4" y1="18" x2="20" y2="18"></line>
            </svg>

            <div className="ev-actions-bar">
              {eventErrors.length !== 0 && (
                <span className="pag-btn" onClick={(e) => { e.stopPropagation(); openModal(); }} title="Log de errores">
                  <img src="/iconos/msgError.png" style={{ height: '14px' }} alt="log" />
                </span>
              )}
              <span className="pag-btn" onClick={(e) => { e.stopPropagation(); exportData(); }} title="Descargar Excel">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7 10 12 15 17 10"></polyline>
                  <line x1="12" y1="15" x2="12" y2="3"></line>
                </svg>
              </span>
              {!props.modalIsOpen && (
                <span className="pag-btn" onClick={(e) => { e.stopPropagation(); props.setAlertsIsOpen(false); }} title="Minimizar">
                  <svg width="10" height="10" viewBox="0 0 10 10">
                    <polyline points="2,6.5 5,3.5 8,6.5" fill="none" stroke="#6b7280" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              )}
              <span className="pag-btn" onClick={(e) => { e.stopPropagation(); props.action(); }} title={props.modalIsOpen ? "Restaurar" : "Maximizar"}>
                <img src={props.modalIsOpen ? "/iconos/minimize.svg" : "/iconos/maximize.svg"} style={{ height: '14px' }} alt="expand" />
              </span>
            </div>
          </>
        )}
        {(!props.modalIsOpen && !props.alertsIsOpen) && (
          <div className="ev-title" style={{ padding: '0 12px', color: 'var(--txt3)' }}>
            {lang[props.languaje]['eventos'].toUpperCase()} ({props.dataProblems.loading ? '...' : contZabbix})
          </div>
        )}
      </div>
      <div className="ev-table-wrap">
        <table className="ev-table">
          <thead className="ev-table-thead">
            <tr>
              <th style={{ width: '32px' }}>
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={(e) => { e.stopPropagation(); handleSelectAll(); }}
                />
              </th>
              <th>SEV.</th>
              <th>INCIDENCIA</th>
              <th>DISPOSITIVO</th>
              <th>ESTATUS</th>
              <th>ODD</th>
              <th>DDT</th>
              <th>ACK</th>
              <th>TICKET</th>
              <th>SLA</th>
              <th>T. ACTUAL</th>
              <th>FECHA</th>
              <th>HORA</th>
            </tr>
          </thead>
          <tbody className="ev-table-tbody">
            {
              (props.dataProblems.loading) ? (
                <tr><td colSpan="13" style={{ textAlign: 'center', padding: '20px' }}><LoadAlerts mode={props.mode}></LoadAlerts></td></tr>
              )
                : (dataList.length == 0) ? (
                  <tr><td colSpan="13" style={{ textAlign: 'center', padding: '20px', color: '#9ca3af' }}>Sin alertas</td></tr>
                ) :
                  dataList.slice(startLimitRow, endLimitRow).map((elemento, index) => (
                    <RowProblem
                      key={elemento.eventid}
                      mapAux={props.mapAux}
                      dataAgencies={props.dataAgencies}
                      dataCriticalities={props.dataCriticalities}
                      poolRows={poolRows}
                      setPoolRows={setPoolRows}
                      poolObjectRows={poolObjectRows}
                      setPoolObjectRows={setPoolObjectRows}
                      setSearchTerm={props.setSearchTerm}
                      search_problems={props.search_problems}
                      server={props.server}
                      handleShowPopup={props.handleShowPopup}
                      languaje={props.languaje}
                      mode={props.mode}
                      data={elemento}
                      origen={props.origen}
                      filtraOrigen={filtraOrigen}
                      ubiActual={props.ubiActual}
                      userPermissions={props.userPermissions}
                      setSuveryId={props.setSuveryId}
                      setImportModalOpen={props.setImportModalOpen}
                    />
                  ))
            }
          </tbody>
        </table>
      </div>

      <div className="ev-footer">
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Paginador
            pages={pages}
            pageActual={pageActual}
            setPageActual={setPageActual}
            mode={''}
          />
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span>Filas por página:</span>
            <select value={limitList} className="pag-select" onChange={handleSelectChange}>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={200}>200</option>
              <option value={500}>500</option>
            </select>
          </div>
        </div>
        <div>
          ({startLimitRow + 1} - {Math.min(endLimitRow, dataList.length)}) de {dataList.length} resultados
        </div>
      </div>
      <Modal
        isOpen={modalLogIsOpen}
        // onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        {
          (eventErrors.length == 0) ? '' :
            // <div className={(props.alertsIsOpen && props.modalIsOpen==false)?'contEventsError':'contEventsErrorOpened'} style={{display:(openEventErrors)?'block':'none'}}>
            <div className='contEventsErrorModal' >
              <div className='titleContEventsError'>
                Log de errores eventos
              </div>
              <div className='compactcontEventsError'>
                <div className='contLogsEventsError'>
                  {
                    eventErrors.map((element, index) => (

                      <div className='RowGlobeLogError'>
                        <div className='globeLogError'>
                          <div className='bodyGlobeLogError'>
                            <div className='indexGlobeLogError' >
                              Error {(index + 1)}
                            </div>
                            <div className='compactInfoGlobeLogError'>
                              <div className='msgGlobeError'>
                                {element.mensaje}
                              </div>
                              <div className='detailGlobeError'>
                                {element.detalle_str}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    ))
                  }

                </div>

              </div>
            </div>
        }
      </Modal>
      <Modal
        isOpen={modalAddCorIsOpen}
        // onAfterOpen={afterOpenModal}
        onRequestClose={closeModalAddCor}
        style={addHostModalStyles}
        contentLabel="Example Modal"
      >
        <ModalAddProblem editActive={false} search_problems={props.search_problems} poolObjectRows={poolObjectRows} setPoolObjectRows={setPoolObjectRows} poolRows={poolRows} server={props.server} handleShowPopup={props.handleShowPopup} setPoolRows={setPoolRows} languaje={props.languaje} mode={props.mode} closeAddHostModal={closeModalAddCor} />
      </Modal>
      <Modal
        isOpen={modalMasiveDeleteIsOpen}
        // onAfterOpen={afterOpenModal}
        onRequestClose={closeModalMasiveDelete}
        style={MasiveDeleteModalStyles}
        contentLabel="Example Modal"
      >
        <ModalMasiveDelete server={props.server} handleShowPopup={props.handleShowPopup} languaje={props.languaje} mode={props.mode} closeModalMasiveDelete={closeModalMasiveDelete} />
      </Modal>
    </>
  )
}

export default TableAlerts 